// src/features/landing/utils/hydrateProductDetails.js
import API from "@/utils/api"; // ✅ Next alias (points to src/utils/api/index.js)

export async function hydrateProductDetails(product, opts = {}) {
  if (!product?.offerId && !product?.sku) {
    throw new Error("Missing offerId or sku");
  }
  const id = product.offerId || product.sku;

  const type = String(product.type || product.productType || "voucher")
    .trim()
    .toLowerCase();

  let endpoint;
  switch (type) {
    case "voucher":
      endpoint = `/vouchers/offers/${encodeURIComponent(id)}`;
      break;
    case "topup":
      endpoint = `/topups/offers/${encodeURIComponent(id)}`;
      break;
    case "esim":
      endpoint = `/esim/offers/${encodeURIComponent(id)}`;
      break;
    default:
      throw new Error(`Unsupported product type: ${type}`);
  }

  try {
    const res = await API.get(endpoint, { signal: opts.signal });
    const raw = res?.data || {};
    const base = raw.offer || raw;

    const send = base.send ?? base.fullDetail?.send ?? null;

    let price = base.price ?? base.fullDetail?.price ?? null;

    // synthesize price block if stored as flat minor+divisor
    if (
      !price &&
      typeof base.price === "number" &&
      (base.priceCurrency || base.priceCurrencyDivisor)
    ) {
      price = {
        currency: base.priceCurrency || "USD",
        currencyDivisor: base.priceCurrencyDivisor ?? 100,
        fixed: base.price,
      };
    }

    return {
      ...base,
      price: price || null,
      send,
      fullDetail: base.fullDetail || base,
      description:
        base.description ??
        base.fullDetail?.description ??
        base.shortNotes ??
        base.notes ??
        "",
      productType: base.productType || product.productType || type.toUpperCase(),
      offerId: base.offerId || id,
      details: base.details ?? base.fullDetail?.details ?? null,
      redemptionInstructions:
        base.redemptionInstructions ??
        base.redemption_instructions ??
        base.fullDetail?.redemptionInstructions ??
        [],
      brandInfoPdf: base.brandInfoPdf ?? base.fullDetail?.brandInfoPdf ?? "",
    };
  } catch (err) {
    const errorData = err.response?.data;
    const msg =
      typeof errorData === "string"
        ? errorData
        : errorData?.error || err.message || "Unknown error";
    console.warn(
      `⚠️ Failed to hydrate product [${id}]: ${msg}`,
      err.response?.status
    );
    throw new Error(`Failed to hydrate product: ${msg}`);
  }
}
